import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
// components
import PrimaryButton from "../PrimaryButton";
import { AddIcon } from "../../Styles/Icons";
// Hooks
import { useReportsHook, useFade } from "../../Services/Hooks";
import { useViewport } from "../ViewportProvider";
import CreateNewReportModal from "../CreateNewReportModal";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";

const DashboardButtonsReports = () => {
  const navigate = useNavigate();
  const { width } = useViewport();
  const isMobile = width <= 1200;
  const server = useSelector((state) => state.session.server);
  const serviceUsers = useSelector((state) => state.serviceUsers);

  const track = useAmplitudeTracking();

  const trackReports = (eventProperties) => {
    track("Reports Creation", { ...eventProperties, location: "dashboard" });
  };

  // custom hooks
  const { reportTypes, createReport } = useReportsHook(server, navigate);

  const reportTypesWithV1 = useMemo(
    () => [...reportTypes, { id: "general-report", title: "Behaviour Report" }],
    [reportTypes]
  );
  // Fade Modal
  const [isVisible, setShowAnimation, showAnimation] = useFade(false, 150); // make sure this is in sync with the NewStyleModal fade_out transition, which is currently set to 200ms. We want the setTimeout to remove the modal before the fade_out transition ends so that we don't deal with the double flash of the modal (perhaps due to race conditions, its unclear)

  // we don't want to show the new report button on mobile
  if (isMobile) return null;

  return (
    <div>
      <div className={styles.dashboard_buttons}>
        <PrimaryButton
          className={styles.add_report_button}
          startIcon={<AddIcon />}
          onClick={() => {
            trackReports({ action: "form_opened" });
            setShowAnimation(true);
          }} //kicks off a series of actions controlled by the useFade hook
          // when set to True, the useEffect hook then sets the NewModal visibility to true
          // when showAnimation is true, then the class ".fade_in" animation kicks in
        >
          New Report
        </PrimaryButton>
      </div>
      {isVisible && (
        <CreateNewReportModal
          serviceUsers={serviceUsers}
          reportTypes={reportTypesWithV1}
          showAnimation={showAnimation}
          setShowAnimation={setShowAnimation}
          createReport={createReport}
          onTrack={trackReports}
        />
      )}
    </div>
  );
};

export default DashboardButtonsReports;
